<template>
  <transition name="slide-fade" v-if="hide">
    <div class="single-look">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
        <div class="look-nav-center">{{inputValue.materialName}}</div>
        <div class="handle-wrapper" @click="handleData" v-if="statusValue.approveStatus === 0 ">
          <div class="icon-font">&#xec11;</div>
          保存
        </div>
      </div>
      <div class="single-look-content">
        <div class="single-look-content-wrapper">
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.72vw;z-index: 999">物料代码：</div>
              <div class="input-wrapper" style="padding: 0.63vw">
                <div class="popover" style="text-align: left" v-if="inputValue.materialCode.length < 18">
                  {{inputValue.materialCode}}
                </div>
                <div class="detail-item" style="width: 100%;display: block" v-if="inputValue.materialCode.length >= 18">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="inputValue.materialCode">
                    <div class="popover" slot="reference">{{inputValue.materialCode}}</div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">烟叶简称：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="inputValue.materialName" placeholder=""/>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.67vw">烟叶年份：</div>
              <div class="input-wrapper">
                <input v-model="inputValue.year"  placeholder=""/>
              </div>
            </div>
            <div class="input-contain" style="z-index: 999">
              <div class="input-title" style="padding-left: 1.78vw">仓库位置：</div>
              <LoadingTreeStack :moduleType="moduleType"  :content="inputValue.siteName" :editCheckId="inputValue.siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
            </div>
          </div>
          <div class="single-look-content-list" style="z-index: 998">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw;">养护阶段：</div>
              <DropDown :content="getMaintainStageData(inputValue.maintainStage)" :items="maintainStageData" v-on:sendInfo = "showInfoMaintainStag"></DropDown>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">养护天数：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.maintainDays" placeholder=""/>
                <div class="input-suffix">(天)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">调养日期：</div>
              <div class="input-wrapper">
                <el-date-picker
                  v-model="inputValue.aftercareDateStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择调养日期">
                </el-date-picker>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 3.56vw">库龄：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.age" placeholder=""/>
                <div class="input-suffix">（天）</div>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">养护数量：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.maintainCount" placeholder=""/>
                <div class="input-suffix">(担)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">降氧完成时间：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.oxygenReductionDays" placeholder=""/>
                <div class="input-suffix">(天)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">申请日期：</div>
              <div class="input-suffix-wrapper">
                <el-date-picker
                  :disabled="true"
                  v-model="statusValue.createdTime"
                  type="date"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div>
            <div class="input-contain" style="z-index: 997">
              <div class="input-title" style="padding-left: 2.67vw">负责人：</div>
              <DropDownInput type="1" :items="custodianValue" :content="inputValue.principalName" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">申请编号：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="statusValue.applyNum" placeholder=""/>
              </div>
            </div>
            <div class="input-contain" >
              <div class="input-title" style="padding-left: 1.67vw">到期时间：</div>
              <div class="input-wrapper">
               <input disabled="true" v-model="statusValue.expireTime" placeholder=""/>
              </div>
            </div>
            <div class="input-contain" style="opacity: 0;">
              <div class="input-title" style="padding-left: 1.67vw">到期时间：</div>
              <div class="input-wrapper">
               <input disabled="true" />
              </div>
            </div>
            <div class="input-contain" style="opacity: 0;">
              <div class="input-title" style="padding-left: 1.67vw">到期时间：</div>
              <div class="input-wrapper">
               <input disabled="true" />
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title">包芯水分下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.wetCoreChipLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯水分上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.wetCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯温度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.tempCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯温度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.tempCoreChipLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.2vw">CO₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.concentrationCo2Upper" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.15vw">CO₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.concentrationCo2Lower" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内温度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackTempUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内温度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackTempLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>

          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title">垛内湿度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackMoistureUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内湿度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackMoistureLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.oxygenUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.oxygenLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
          </div>
          <div class="text-area-wrapper">
            <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
            <textarea v-model="inputValue.remark" rows="1" class="text-area-input"></textarea>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import DropDownInput from '../../../components/DropDownInput.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import {userList} from '../../../api/system'
import {queryAlarm, detailMaintainPlan, updateMaintainPlan} from '../../../api/maintain'
import {daysDistance, renderTime} from '../../../tools/methods'
export default {
  name: 'SingleLook',
  components: { DropDown, DropDownInput, LoadingTreeStack },
  data () {
    return {
      hide: false,
      moduleType: '01',
      custodianValue: [],
      maintainStageData: [
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      statusValue: {
        createdTime: '',
        concentrationCo2Lower: '',
        concentrationCo2Upper: '',
        oxygenLower: '',
        oxygenUpper: '',
        stackMoistureLower: '',
        stackMoistureUpper: '',
        stackTempLower: '',
        stackTempUpper: '',
        tempCoreChipLower: '',
        tempCoreChipUpper: '',
        wetCoreChipLower: '',
        wetCoreChipUpper: '',
        age: '',
        approveStatus: '',
        applyNum: ''
      },
      inputValue: {
        id: '',
        materialCode: '',
        materialName: '',
        year: '',
        siteName: '',
        siteId: '',
        siteType: '',
        maintainStage: '',
        maintainDays: '',
        aftercareDateStart: '',
        oxygenReductionDays: '',
        maintainCount: '',
        principalId: '',
        principalName: '',
        warehouseBuildTime: '',
        remark: ''
      }
    }
  },
  created () {
    let id = this.$route.query.id
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    detailMaintainPlan({id: id}).then(res => {
      console.log(res)
      this.inputValue.id = res.data.id
      this.inputValue.materialCode = res.data.materialCode
      this.inputValue.materialName = res.data.materialName
      this.inputValue.year = res.data.year
      this.inputValue.siteName = res.data.siteName
      this.inputValue.siteId = res.data.siteId
      this.inputValue.siteType = res.data.siteType
      this.inputValue.maintainStage = res.data.maintainStage
      this.inputValue.maintainDays = res.data.maintainDays
      this.inputValue.aftercareDateStart = res.data.aftercareDateStart
      this.inputValue.oxygenReductionDays = res.data.oxygenReductionDays
      this.inputValue.maintainCount = res.data.maintainCount
      this.inputValue.principalId = res.data.principalId
      this.inputValue.principalName = res.data.principalName
      this.inputValue.warehouseBuildTime = res.data.warehouseBuildTime
      this.inputValue.remark = res.data.remark

      this.statusValue.approverTime = res.data.maintainStageData.approverTime
      this.statusValue.concentrationCo2Lower = res.data.maintainStageData.concentrationCo2Lower
      this.statusValue.concentrationCo2Upper = res.data.maintainStageData.concentrationCo2Upper
      this.statusValue.oxygenLower = res.data.maintainStageData.oxygenLower
      this.statusValue.oxygenUpper = res.data.maintainStageData.oxygenUpper
      this.statusValue.stackMoistureUpper = res.data.maintainStageData.stackMoistureUpper
      this.statusValue.stackMoistureLower = res.data.maintainStageData.stackMoistureLower
      this.statusValue.stackTempLower = res.data.maintainStageData.stackTempLower
      this.statusValue.stackTempUpper = res.data.maintainStageData.stackTempUpper
      this.statusValue.tempCoreChipLower = res.data.maintainStageData.tempCoreChipLower
      this.statusValue.tempCoreChipUpper = res.data.maintainStageData.tempCoreChipUpper
      this.statusValue.wetCoreChipLower = res.data.maintainStageData.wetCoreChipLower
      this.statusValue.wetCoreChipUpper = res.data.maintainStageData.wetCoreChipUpper
      this.statusValue.age = daysDistance(res.data.warehouseBuildTime)
      this.statusValue.createdTime = renderTime(res.data.createdTime)
      this.statusValue.expireTime = renderTime(res.data.expireTime)
      this.statusValue.approveStatus = res.data.approveStatus
      this.statusValue.applyNum = res.data.applyNum
    }).catch(err => {
      console.log(err)
    })
    this.statusValue.approverTime = new Date()
    this.handleSearchValue()
  },
  methods: {
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === '01') {
        return '自然醇化阶段'
      } else if (maintainStage === '02') {
        return '防霉杀虫阶段'
      } else if (maintainStage === '03') {
        return '气调醇化阶段'
      } else {
        return '气调保质阶段'
      }
    },
    showDropInfo: function (data) {
      console.log(data)
      this.inputValue.siteName = data.gatherSite
      this.inputValue.siteId = data.id
      this.inputValue.siteType = data.siteType
      this.statusValue.age = daysDistance(data.warehouseBuildTime)
      this.inputValue.warehouseBuildTime = data.warehouseBuildTime
    },
    showInfoMaintainStag: function (data) {
      console.log(data)
      this.inputValue.maintainStage = data.value
      queryAlarm({phases: data.value}).then(res => {
        this.statusValue.concentrationCo2Lower = res.data.concentrationCo2Lower
        this.statusValue.concentrationCo2Upper = res.data.concentrationCo2Upper
        this.statusValue.oxygenLower = res.data.oxygenLower
        this.statusValue.oxygenUpper = res.data.oxygenUpper
        this.statusValue.stackMoistureLower = res.data.stackMoistureLower
        this.statusValue.stackMoistureUpper = res.data.stackMoistureUpper
        this.statusValue.stackTempLower = res.data.stackTempLower
        this.statusValue.stackTempUpper = res.data.stackTempUpper
        this.statusValue.tempCoreChipLower = res.data.tempCoreChipLower
        this.statusValue.tempCoreChipUpper = res.data.tempCoreChipUpper
        this.statusValue.wetCoreChipLower = res.data.wetCoreChipLower
        this.statusValue.wetCoreChipUpper = res.data.wetCoreChipUpper
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    showInfo: function (data) {
      console.log(data)
      this.inputValue.principalId = data.id
      this.inputValue.principalName = data.name
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        this.custodianValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    backPath: function () {
      this.$router.go(-1)
    },
    handleData: function () {
      updateMaintainPlan(this.inputValue).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message({
            message: res.data,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  @import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/SingleLook.vue